export default __webpack_public_path__ + "static/media/treat-yourself.02b09851.jpg";